<style xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    .bottom_btn_custom{
        display: inline;
        padding-right: 0px;
        padding-left: 0px;
    }
    .title_body {
        padding:0px;
    }
    .form-control {
        min-width: 147px;
    }

    .registClass {
        color : #321FDB;
    }
    /* 기초 CSS 디자인 */
    * {
        box-sizing:border-box;
    }
    body {
        margin:0;
    }
    .hidden {
        display:none;
        visibility:hidden;
    }

    /* 버튼으로 사용할 라벨 디자인 */
    .button {
        font-size:19px;
        font-weight:600;
        vertical-align:middle;
        cursor:pointer;
    }

    /* 모달 윈도우 디자인 */
    .box_modal {
        position: fixed;
        display: block;
/*        width: 440px;
        height: 350px;*/
        top:50%;
        left:50%;
        margin-top:-75px;
        margin-left:-150px;
        background:#d9e5e9;
        border:1px solid #386980;
        overflow:hidden;
        /* 아래 부분은 애니메이션 효과를 위한 부분 */
        visibility: collapse;
        filter: alpha(opacity=60);
        -webkit-transition: all .2s ease;
        transition: all .2s ease;
        -webkit-transform: scale(0, 0);
        -ms-transform: scale(0, 0);
        transform: scale(0, 0);
    }
    .box_modal:hover {
        opacity: 1;
        filter: alpha(opacity=100);
    }

    /* 닫기 버튼으로 사용할 라벨 */
    .closer {
        position:absolute;
        width:30px;
        height:30px;
        top:0;
        right:0;
        background:#eee;
        border-left:1px solid #386980;
        border-bottom:1px solid #386980;
        text-align:center;
        line-height:26px;
        font-size:16x;
        cursor:pointer;
    }
    .text {
        display:inline-block;
        padding:20px;
    }
    .text h3 {
        font-size:19px;
        margin:0;
    }
    .text p {
        font-size:13px;
    }

    /* 모달 윈도우가 팝업되는 코어 소스 */
    input#modal[type=checkbox]:checked ~ .box_modal {
        visibility: visible;
        -webkit-transform: scale(1, 1);
        -ms-transform: scale(1, 1);
        transform: scale(1, 1);
        z-index: 10;
    }
    .textAreaCustom {
        line-height: 4.8;
    }


</style>
<template>
    <div>
        <form style="width: 100%" @submit.prevent="submit">
            <CCard>
                <CCardHeader>
                    <CIcon name="cil-justify-center"/> <strong> 회사관리 </strong>
                    <small></small>
                </CCardHeader>
                <CCardBody class="title_body" >
                    <CNavbar light color="light">
                        <CForm inline>
                            <div role="group" class="form-group form-row">
                                <div class="col-sm-9 input-group-sm">
                                    <CInput
                                            class="mr-sm-2"
                                            placeholder="이름,회사이름,전화번호"
                                            size="sm"
                                            v-model="searchVal"
                                    />
                                </div>
                            </div>
                            <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="searchList" >검색</CButton>
                        </CForm>
                    </CNavbar>
                </CCardBody>
            </CCard>
        </form>
        <CRow>
            <div class="col-sm-12" style="margin-bottom: 10px;">
                <div class="col-sm-0.5">
                    <li class="bottom_btn_custom">
                        <div class="d-inline-block dropdown">
                            <select id="uid-utosbj1koo"  v-model="selectOption"  @change="selectPerPage" class="form-control">
                                <option value="10" selected>10개씩보기</option>
                                <option value="20">20개씩보기</option>
                                <option value="I50">50개씩보기</option>
                            </select>
                        </div>
                    </li>
                       <!-- <li class="bottom_btn_custom" style="float: right;">
                            <CButton label=""
                                     type="button"
                                     style="text-align: right"
                                     class="btn btn-info " @click="goExcelDownload">엑셀 다운로드
                            </CButton>
                    </li>-->
                </div>
            </div>
        </CRow>
        <CRow>
            <CCol sm="12">
                <div bordered="true" small="true">
                    <div class="position-relative table-responsive">
                        <b-table
                                id = "list-table"
                                :items="newItems"
                                :fields="fields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                striped hover
                                @row-clicked="goUpdatePage"
                        >
                            <template v-slot:cell(id)="data">
                            <b  class="text-right">{{data.item.id }}</b>
                            </template>
                            <template v-slot:cell(charge)="data">
                                <div  class="text-right">{{data.item.charge }}</div>
                            </template>
                        </b-table>
                    </div>
                    <div style="float:right;">   </div>
                    <b-pagination
                            :link-gen="linkGen"
                            :number-of-pages="10"
                            use-router
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="list-table"
                    />
                    </div>
            </CCol>
        </CRow>
        <div class="col-sm-0.5">
            <li class="bottom_btn_custom" style="margin-left: 10px">
                <CButton label=""
                          type="button"
                          style="text-align: right"
                          class="btn btn-info " @click="insertCompany">회사추가
            </CButton></li><!--
            <li class="bottom_btn_custom" style="float: right;">
                <CButton label=""
                         type="button"
                         style="text-align: right; margin:0;padding: 0;"
                         class="btn btn-info" @click="handle_toggle">
                        <label for="modal" @click="handle_toggle" style="margin-bottom: 0; padding: 6px 12px; cursor: pointer;">알림메시지 전송</label>
                </CButton>
            </li>

            <input type="checkbox" id="modal" class="hidden">
            <div class="box_modal">
                <label for="modal" class="closer">x</label>
                <div class="text">

                    <h3>푸시 메시지  <small style="font-size: 12px;"> (검색된 리스트 전체에 전송됩니다.)</small></h3>
                    <p>
                    <div role="group" class="form-group form-row">
                        <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 제목 </label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <input class="form-control" id="uid-rw1ppxoxk3h" type="text" name="input3-group1" style="width: 350px;"   v-model="title" >
                            </div>
                        </div>
                    </div>
                    <CRow form class="form-group">
                        <CCol tag="label" sm="3" class="col-form-label">
                            <div class="form-check form-check-inline mr-1">
                                <label class="form-check-label" for="inline-checkbox1">내용</label>
                            </div>
                        </CCol>
                        <div class="col-md-9 col-form-label" style="height: 150px;" >
                            <textarea class="textAreaCustom form-control" v-model="msg">

                            </textarea>
                        </div>
                    </CRow>
                    <CButton label=""
                             type="button"
                             style="text-align: center; margin:0; float: right;"
                             class="btn btn-info" @click="sendMsg">
                        전송
                    </CButton>
                </div>
            </div>-->
        </div>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    export default {
        name: 'app',
        components: {},
        data: function () {
            return {
                perPage: 10,
                selectOption :10,
                currentPage: 1,
                newItems: [],
                fields: [
                    {
                        key: 'companyId',
                        label: 'No',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: '이름',
                        sortable: true
                    },
                    {
                        key: 'registNo',
                        label: '단체등록번호',
                        sortable: true
                    },
                    {
                        key: 'enabledYn',
                        label: '활성화여부',
                        sortable: true
                    },
                    {
                        key: 'insertTime',
                        label: '등록일',
                        sortable: true
                    },
                    {
                        key: 'updateTime',
                        label: '변경일',
                        sortable: true
                    },
                ],
                items: null,
                searchVal: null,
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        computed: {
            rows() {
                return this.newItems.length;
            }
        },
        mounted() {
            this.searchList();
        },
        methods: {
            searchList(value){
                const qs = require('querystring');
                const formData = qs.stringify({'searchVal': this.searchVal
                });

                axios.post('silver/getCompanyList', formData)
                    .then(res => {
                        this.items = res.data;
                        this.newItems = [];

                        // 입퇴원 상태 변환   ex) O -> 입원
                     /* paymentCompCnt: 0,
                        paymentMinssCnt:  0,
                        paymentAll: 0,
                        paymentMiss: 0 */

                        for(var i = 0; i < this.items.length; i++){
                            const obj = new Object();


                            obj.companyId = this.items[i].companyId;
                            if(this.items[i].enabledYn === 'Y'){
                                obj.enabledYn = "활성화"
                               /* this.paymentCompCnt = this.paymentCompCnt + 1;*/
                            } else {
                                obj.enabledYn = "비활성화";
                                obj._rowVariant = "danger";
                            }

                            obj.name = this.items[i].name;
                            obj.manager = this.items[i].manager;
                            obj.managerPhone = this.items[i].managerPhone;
                            obj.registNo = this.items[i].registNo;

                            if(this.items[i].insertTime === null || this.items[i].insertTime === ""){
                                obj.insertTime = "";
                            }else {
                                obj.insertTime = this.$moment(this.items[i].insertTime).format('YYYY-MM-DD');
                            }

                            if(this.items[i].updateTime === null || this.items[i].updateTime === ""){
                                obj.updateTime = "";
                            }else {
                                obj.updateTime = this.$moment(this.items[i].updateTime).format('YYYY-MM-DD');
                            }

                            this.newItems.push(obj);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
          /*  allCount(){
                axios.post('silver/cust/getCustListCnt',{'searchVal': this.searchVal
                    ,'custStatus': this.custStatus
                    ,'chargeStatus': this.chargeStatus
                })
                    .then(res => {

                        console.log(res.data)
                        this.paymentCompCnt = res.data.paymentCompCnt ,
                        this.paymentMissCnt = res.data.paymentMissCnt,
                        this.totalMissAmount = res.data.totalMissAmount
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },*/

            insertCompany() {
                this.$router.push({name: 'companyinsert'});
            },

            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },

            linkGen(pageNum) {
                return pageNum === 1 ? '?' : '?page=${pageNum}';
            },

            goUpdatePage(record, index) {
                this.$router.push({name: 'companyupdate', params: {companyId: record.companyId}});
            }

            , selectPerPage () {
                this.perPage =  this.selectOption;
            }
        }
    }
</script>